module.exports = __webpack_public_path__ + "static/media/alert.0e36e660.mp3";